import React, {useState} from 'react';
import {useTranslation} from "react-i18next";

import expand from "../../../../assets/images/ic_expand.png";
import Colors from "../../../../assets/colors/Colors";
import styled from "styled-components";

const Blanket: React.FC<{ onClick: () => void }> = (props) => (
    <div style={{ bottom: 0, left: 0, top: 0, right: 0, position: "fixed", zIndex: 1 }}
        {...props}
    />
);

const Options: React.FC = (props) => {
    return (
        <div id='options' style={{ backgroundColor: "white", borderRadius: 4, position: "absolute", zIndex: 99, flex: 1, width: '100%' }}
            {...props}
        />
    );
};

interface DropdownProps {
    optionsComponent?: React.ReactElement,
    isOpen: boolean,
    displayComponent: React.ReactElement,
    onClose: () => void
}

const Dropdown: React.FC<DropdownProps> = ({ optionsComponent, isOpen, displayComponent, onClose }) => (
    <div id='dropdown'>
        {displayComponent}
        {isOpen ? <Options>{optionsComponent}</Options> : null}
        {isOpen ? <Blanket onClick={onClose} /> : null}
    </div>
);

const ExpandIcon = () => (
    <div style={{display: 'block', margin: 'auto'}}>
        <img src={expand} alt="Logo2" style={{height: 10, width: 10, filter: `brightness(0) invert(1)`}} />
    </div>
);


const LanguageOptionDiv = styled.div `
    padding: 10px;
    font-size: 18;
    color: white;
    width: 100%;
`;

interface languageProps { value: string, label: string, shortLable: string}

const LanguageSelector: React.FC<{customStyle?: object}> = ({customStyle}) => {
    const { t, i18n } = useTranslation();

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [language, setLanguage] = useState<languageProps>({value: 'es', label: 'Español', shortLable: 'ES'});
    const spanish = {value: 'es', label: 'Español', shortLable: 'ES'};
    const english = {value: 'en', label: 'English', shortLable: 'EN'};

    const toggleOpen = () => {
        setIsOpen(!isOpen)
    };

    const onSelectChange = (language: languageProps) => {
        toggleOpen();
        setLanguage(language);
        i18n.changeLanguage(language.value)
    };

    return (
        <div id='languageContainer' className='languageSelectorContainer'>
            <Dropdown
                isOpen={isOpen}
                onClose={toggleOpen}
                displayComponent={
                    <div style={{display: 'flex', flexDirection: 'row'}} onClick={toggleOpen}>
                        <LanguageOptionDiv style={{flex: 1, marginRight: 5,}}>{ language.shortLable }</LanguageOptionDiv>
                        <ExpandIcon />
                    </div>
                }
                optionsComponent={
                    <div style={{
                        position: "absolute",
                        backgroundColor: Colors.headerNavigationRed,
                        paddingLeft: 10, paddingRight: 15, paddingTop: 10,
                        paddingBottom:10,
                        width: 'inherit'
                    }}>
                        <LanguageOptionDiv onClick={() => onSelectChange(spanish)}>{ spanish.label } </LanguageOptionDiv>
                        <LanguageOptionDiv onClick={() => onSelectChange(english)}>{ english.label } </LanguageOptionDiv>
                    </div>
                }
            />
        </div>
    )
};


export default LanguageSelector;
